import { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import type { Role } from '@venturewrist/shared';
import { useAuth, useSignup } from '../hooks/queries';
import { ApiError } from '../lib/api';
import { Button, Field, Input, Select, ErrorNote } from '../components/ui';
import { AuthShell } from './AuthShell';

export function Signup() {
  const { user } = useAuth();
  const signup = useSignup();
  const nav = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState<Role>('student');

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    signup.mutate({ name, email, password, role }, { onSuccess: () => nav('/dashboard') });
  };

  return (
    <AuthShell title="Create your account" subtitle="Play and run smart-watch business simulations">
      <form onSubmit={submit} className="space-y-4">
        <Field label="Name">
          <Input required value={name} onChange={(e) => setName(e.target.value)} />
        </Field>
        <Field label="Email">
          <Input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label="Password" hint="At least 8 characters">
          <Input type="password" autoComplete="new-password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Field label="I am a…">
          <Select value={role} onChange={(e) => setRole(e.target.value as Role)}>
            <option value="student">Student</option>
            <option value="instructor">Instructor</option>
          </Select>
        </Field>
        <ErrorNote>{signup.error ? (signup.error as ApiError).message : null}</ErrorNote>
        <Button type="submit" className="w-full" disabled={signup.isPending}>
          {signup.isPending ? 'Creating…' : 'Create account'}
        </Button>
      </form>
      <p className="mt-4 text-center text-sm text-mut">
        Already have an account? <Link to="/login" className="text-acc hover:underline">Sign in</Link>
      </p>
    </AuthShell>
  );
}
